import BankAccountVerifier from './bank-account-verifier';

class ApplicationLevelDialogs {

  constructor(application) {

    this.application = application;

  }

  displayBankAccountVerifier(data) {

    this.application.dialogsManager.display(BankAccountVerifier, data);

  }

}

export default ApplicationLevelDialogs;